import { Component, Input, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Authority } from 'src/app/shared/models/security/authority';
import { FacadeService } from '../../services/facade.service';

@Component({
	selector: 'app-mobile-navbar',
	templateUrl: './mobile-navbar.component.html',
	styleUrls: ['./mobile-navbar.component.scss']
})
export class MobileNavbarComponent implements OnInit {
	/* Listing des liens accessibles depuis le menu */
	menuItems: {
		name: string;
		path: string;
		parentPath: string;
		iconClass: string;
	}[] = [];

	constructor(private facade: FacadeService) {}

	ngOnInit(): void {
		this.initNavbar();
	}

	/**
	 * Initialise les éléments du tableau représentant la navbar
	 * @param authority id du profile
	 */
	initNavbar(): void {
		this.menuItems.push(
			{
				name: 'Tableau de bord',
				path: '/dashboard',
				parentPath: '/dashboard',
				iconClass: 'bi bi-house-door-fill'
			},
			{
				name: 'Bénéficiaires',
				path: '/beneficiaires/list',
				parentPath: '/beneficiaires/list',
				iconClass: 'bi bi-person-fill'
			},
			{
				name: 'Prestations',
				path: '/prestation/appuis-specifiques',
				parentPath: '/prestation',
				iconClass: 'bi bi-folder2-open'
			},
			{
				name: 'Administration',
				path: '/gestion/users',
				parentPath: '/gestion',
				iconClass: 'bi bi-pencil-square'
			},
			{
				name: 'Paramétrage',
				path: '/parametrage/amenagement',
				parentPath: '/parametrage',
				iconClass: 'bi bi-gear-fill'
			},
			{
				name: 'Système',
				path: '/systeme/systeme/form',
				parentPath: '/systeme/systeme',
				iconClass: 'bi bi-wrench'
			},
			{
				name: 'Mon compte',
				path: '/espace-perso',
				parentPath: '/espace-perso',
				iconClass: 'bi bi-person-fill'
			},
			{
				name: 'Se déconnecter',
				path: '/',
				parentPath: '/',
				iconClass: 'bi bi-escape'
			}
		);
	}

	toggleNavbarAndDoAction(tabName: string) {
		document.getElementById('toggler-button').click();
		if (tabName === 'Se déconnecter') {
			this.signOut();
		}
	}

	/**
	 * Efface les éléments stockés en cache
	 */
	signOut() {
		//this.facade.notificationService.ngOnDestroy();
		this.facade.messageService.ngOnDestroy();
		this.facade.dataStorageService.clearStorage();
		this.facade.dataStorageService.setJwtToken('');
		location.reload();
	}
}
